import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sli_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitLead = (data) => api.post("/leads", data).then((r) => r.data);
